module.exports = __webpack_public_path__ + "img/procustomers.b439726d.svg";